import ReactOnRails from 'react-on-rails';
import CheckoutPage from './pages/Checkout';
import './service/i18n';

ReactOnRails.register({ CheckoutPage });
